import { inventoryRestZ, round3, type RestMover, type RestWorld } from './floor-move';
import type { InventoryMoveReceipt } from '../../ft3d-move-handlers/inventory-move-receipt';

export type DropPoint = { x: number; y: number; z: number };
export interface ServerDropContext { actorId: string | null; moveType: string; shape?: unknown }

/** Only the aftermath of an actual committed world transfer; ordinary carried updates have no falling duty. */
export function serverDropDestination(receipt: InventoryMoveReceipt, moveType: string): string | null {
  const destination = receipt.move.destination;
  const eid = destination.possess_id.toUpperCase();
  if (destination.deleted_after || destination.item_qty_after <= 0
    || !receipt.affected_encounter_ids.some(id => id.toUpperCase() === eid)
    || !['drop_inventory', 'throw_inventory', 'disarm_inventory', 'move_inventory'].includes(moveType)
    || (receipt.move.source.possess_id_before.toUpperCase() === eid
      && receipt.move.source.inventory_id.toUpperCase() === destination.inventory_id.toUpperCase() && moveType !== 'throw_inventory')) return null;
  return eid;
}

/** A carried placement loses its old pin; piloted/integrated objects retain their native exclusion. */
export function planServerDrop(world: RestWorld, mover: RestMover, point: DropPoint, piloted: boolean, carried = true) {
  if (piloted) return { after: point, rest: 'placed' as const, fallFt: 0, unpin: false };
  const rest = inventoryRestZ(world, { ...mover, mounted: carried ? false : mover.mounted }, point.x, point.y, point.z, false);
  return { after: { ...point, z: rest.z }, rest: rest.rest,
    fallFt: rest.rest === 'fell' ? round3(Math.max(0, point.z - rest.z)) : 0, unpin: carried && mover.mounted };
}
